import React from "react";
import Map from "../components/map/Map.jsx";
import PublicContext from "../contexts/PublicContext.jsx";
import { SensorsMapProvider } from "../contexts/SensorsMapProvider.jsx";

function MapPage() {
	return (
		<PublicContext>
			<div className="w-full h-[75vh] flex flex-col">
				<SensorsMapProvider>
					<Map isAuthenticated={true} />
				</SensorsMapProvider>
			</div>
		</PublicContext>
	);
}

export default MapPage;
